import React from 'react'
import { useStyles } from './style'
import { Box, Grid, Typography } from '@mui/material'
import { parseISO } from 'date-fns'
import { generatePath } from 'react-router'
import { routes } from '../../../routes'
import { Link } from 'react-router-dom'

const AssessmentItem = ({ assessment, index }) => {
  const classes = useStyles()

  return (
    <>
      <Link to={generatePath(routes.assessmentEdit.path, { assessmentId: assessment.externalId })} style={{ textDecoration: 'none', color: '#000' }}>
        <Grid
          role='row button'
          data-test={`assessment-list-item-${index}`}
          container
          tabIndex={0}
          direction='row'
          alignItems='center'
          className={classes.gridRow}
        >
          <Grid item md={5} className={classes.titleColumn}>
            <Typography variant='body2'>
              {assessment.title}
            </Typography>
          </Grid>
          <Grid item md={5}>
            <Box display='flex' alignItems='center'>
              <Box>
                <Typography variant='body2'>
                  {assessment.externalId}
                </Typography>
              </Box>
            </Box>
          </Grid>
          <Grid item md={2}>
            <Typography variant='body2'>
              {parseISO(assessment.lastUpdate).toLocaleDateString()}
            </Typography>
          </Grid>
        </Grid>
      </Link>
    </>
  )
}

export default AssessmentItem
